import React from 'react';
import * as S from '../SrpTab/SrpTab.styles';

const SrpTab = () => (
  <>
    <S.SrpTabDiv>
      <S.HotelIconSpan />
      <S.HotelTypeSpan />
    </S.SrpTabDiv>
    <S.SrpTabDiv>
      <S.HotelIconSpan />
      <S.HotelTypeSpan />
    </S.SrpTabDiv>
    <S.SrpTabDiv>
      <S.HotelIconSpan />
      <S.HotelTypeSpan />
    </S.SrpTabDiv>
    <S.SrpTabDiv>
      <S.HotelIconSpan />
      <S.HotelTypeSpan />
    </S.SrpTabDiv>
  </>
);

export default SrpTab;
